import { Projects } from '@/modules/projects/types';
import { UserRoles } from '@/enums';

const access_roles = {
  [Projects.Pages.PROJECTS]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.SALE_MANAGER,
    UserRoles.Internal.SALE_MANAGER_FULL_PRICE,
  ],
  [Projects.Pages.PROJECT_DETAIL]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.SALE_MANAGER,
    UserRoles.Internal.SALE_MANAGER_FULL_PRICE,
  ],
  [Projects.Pages.PROJECT_NEW]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.SALE_MANAGER,
    UserRoles.Internal.SALE_MANAGER_FULL_PRICE,
  ],
};

export default access_roles;
